import { render, staticRenderFns } from "./TextVersion.vue?vue&type=template&id=23fb7b96&"
import script from "./TextVersion.vue?vue&type=script&lang=js&"
export * from "./TextVersion.vue?vue&type=script&lang=js&"
import style0 from "./TextVersion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TextVersion.vue"
export default component.exports